import React from 'react';

import { ImageWidgetDataProvider } from '../../../components/Widgets/ImageWidget/ImageWidgetDataProvider';
import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { ExistingStudentWidgetProps } from '../Widget';
import { StudentImage } from './StudentImage';
import { Alignment, ImageWidget as ImageWidgetModel } from '@ael/core-api';
import classNames from 'classnames';

import './image-widget.scss';

export const ImageWidget: React.FC<ExistingStudentWidgetProps> = ({ widget }) => {
  const { value: imageWidgetValue } = widget as ImageWidgetModel;

  return (
    <StudentWidgetWrapper>
      <ImageWidgetDataProvider assetId={imageWidgetValue.data.assetId} widgetId={widget._id}>
        {(data) => {
          if (data) {
            return (
              <figure
                className={classNames(
                  'student-image-widget',
                  { 'student-image-widget--align-left': imageWidgetValue.properties.alignment === Alignment.left },
                  { 'student-image-widget--align-right': imageWidgetValue.properties.alignment === Alignment.right }
                )}
              >
                <StudentImage
                  url={data.assetUrl}
                  imageWidth={data.imageWidth}
                  imageHeight={data.imageHeight}
                  properties={imageWidgetValue.properties}
                />
                {imageWidgetValue.properties.caption && (
                  <figcaption className="student-image-widget__caption">
                    {imageWidgetValue.properties.caption}
                  </figcaption>
                )}
              </figure>
            );
          }
          return null;
        }}
      </ImageWidgetDataProvider>
    </StudentWidgetWrapper>
  );
};
